var _this = this;
import * as tslib_1 from "tslib";
import { setSearchText, setSelectedSuggestionIndex, updateGhostText, } from '../actions/internalActions';
import { changeSelectedSuggestionViaKeyboard, clearSearchBox, addSuggestionPill, } from '../actions/publicActions';
import { getStore } from '../store/store';
import { SuggestionKind, lazyLogSearchBoxStateChanged } from 'owa-search-service';
import { orchestrator } from 'satcheljs';
export default orchestrator(changeSelectedSuggestionViaKeyboard, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var indexToSelect, suggestionToSelect;
    return tslib_1.__generator(this, function (_a) {
        indexToSelect = actionMessage.indexToSelect;
        suggestionToSelect = actionMessage.suggestionToSelect;
        // Dispatch action to clear search box.
        clearSearchBox();
        // Add suggestion to SearchInput (based on kind).
        switch (suggestionToSelect.kind) {
            case SuggestionKind.Category:
            case SuggestionKind.People:
                addSuggestionPill(suggestionToSelect, false /* suggestionSelected */);
                break;
            case SuggestionKind.Keywords:
                setSearchText(suggestionToSelect.QueryText);
                break;
            case SuggestionKind.Message:
            case SuggestionKind.Files:
                setSearchText(getStore().searchTextForSuggestion);
                break;
        }
        // Update the selected index in the store.
        setSelectedSuggestionIndex(indexToSelect);
        // Update ghost text (gets cleared).
        updateGhostText();
        /**
         * Log that search box state changed because of keyboard navigation
         * (if using 3S and is a 3S suggestion, i.e. QF request ID exists and there
         * is non-empty searchTextForSuggestion).
         */
        if (getStore().isUsing3S && getStore().latestTraceId && getStore().searchTextForSuggestion) {
            lazyLogSearchBoxStateChanged.importAndExecute(new Date() /* currentTime */, 'navigation' /* reason */, suggestionToSelect.ReferenceId, getStore().latestTraceId);
        }
        return [2 /*return*/];
    });
}); });
//# sourceMappingURL=changeSelectedSuggestionViaKeyboardOrchestrator.js.map